import {TopCategoryInterface} from "../../../interfaces/catalog/TopCategoryInterface";
import {Link} from "react-router-dom";
import {useState} from "react";
import {formatBoldText} from "../../../utils/formatBoldText";

export default function CatalogMenuItem({topCategory}: { topCategory: TopCategoryInterface })
{
    const [isOpen, setIsOpen] = useState(false);

    return (<li>
        <div className={'d-flex flex-column link-drop mob-menu__link mob-menu__link-drop ' + (isOpen ? '_active' : '')}>
            <div className="d-flex align-items-center justify-content-between gap-3 link-drop__head" onClick={() => {setIsOpen(!isOpen)}}>
                <span>{formatBoldText(topCategory.category.name)}</span>
                <svg width="12" height="6" viewBox="0 0 12 6" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M11.0193 -4.81668e-07L12 0.892352L6.65505 5.75277C6.56941 5.83112 6.46756 5.8933 6.35538 5.93573C6.2432 5.97816 6.12289 6 6.00139 6C5.87988 6 5.75958 5.97816 5.6474 5.93573C5.53521 5.8933 5.43337 5.83112 5.34773 5.75277L-2.23262e-07 0.892353L0.980725 0.000840621L6 4.56269L11.0193 -4.81668e-07Z"
                        fill="#A0A0A0"/>
                </svg>
            </div>
            <ul className="d-flex flex-column gap-3 mob-menu__list">
                {topCategory.items.map(category => <li key={category.catalog_code}><Link to={'/catalog/list/' + category.catalog_code + '/' + category.human_url} className="mob-menu__link">{formatBoldText(category.name)}</Link></li>)}
            </ul>
        </div>
    </li>)
}